<template>
    <modal
        v-if="vinPrinting"
        :title="isDryBox ? $t('DryBox.print_labels') : $t('OrderCurrent.modal.printVin.title')"
        @close-request="clearSelected()"
        closable
      >
      <div id="vinPrint">
        <table-element
          :title="$t('OrderCurrent.modal.selected_orders')"
          :arrOfElement="arrOfOrder"
          :fields="fieldsObjVIN"
          :isShowFilter="false"
          :isShowSelectAll="false"
          :hideTitleonPrint=this.hideTitleonPrint
          :sortSpacing="0"
          class="mx-2 mt-4"
        >

          <template #header-actions>
            <p class="m-2 mb-0 mt-2">{{$t('OrderCurrent.count')}} {{arrOfOrder.length}}</p>
          </template>

          <template #pre-body-content>
            <div class="preBody" style="display: flex; justify-content: space-between;">
              <img id='logo' :src="user.logo" class="" style="width: 100; height: 100; margin-right: 200px;">
              <div class="address-info" style="display: flex; flex-direction: column;">
                <h3 style="margin-bottom: 0.3em; margin-top: 1em;">{{user.name}}</h3>
                <p style="margin-bottom: 0.1em; word-wrap: break-word; overflow-wrap: break-word;">{{ user.address }}</p>
                <p style="margin-bottom: 0.1em;">{{ user.city }}, {{ user.province }}, {{ user.postcode }}</p>
                <p style="margin-bottom: 0.1em;">Phone: {{user.phone}}</p>
                <p style="margin-bottom: 0.6em;">Fax: {{user.fax }}</p>
              </div>
            </div>
          </template>

          <template #body-content-desktop="content">
            <!-- List of orders -->
            <tr v-for="(order, index) in content.results"
            class="table-element_hover text-center"
            :key="index">
              <td>
                {{order.orderNumber}}
              </td>
              <td>
                <barcode :value="order.vin" format="CODE128A" >
                  {{ isDryBox ? $t('DryBox.no_order_number') : $t('OrderCurrent.modal.printVin.noVin') }}
                </barcode>
              </td>
              <td>
                {{order.make}}
              </td>
              <td>
                {{order.model}}
              </td>
              <td>
                {{order.year}}
              </td>
              <td>
                {{order.numRef || '-'}}
              </td>
              <td>
                {{order.transmitterName}}
              </td>
              <td>
                {{order.receiverName}}
              </td>
            </tr>
          </template>

          <template #post-body-content>
            <div class="mt-2">
              <button class="btn btn-kne-orange float-right m-1" @click="sendToPrint()">{{$t('OrderCurrent.actions.printVin')}}</button>
            </div>
          </template>

        </table-element>
      </div>
    </modal>
</template>

<script>
import Modal from '../../interface-components/Modal.vue'
import TableElement from '../Table-component/Table-Element.vue'
import regularInput from '../../basic-components/regularInput.vue'
import printJS from 'print-js'
import { dryBoxMixin } from '../../../../utils/dryBoxLabels'

export default {
    name: 'UpdatePayerModal',
    components: {
        Modal,
        TableElement,
        regularInput
    },

    mixins: [dryBoxMixin],

    data () {
        return {
            fieldsObjVIN: [
                {
                    text: this.$t('OrderCurrent.order'),
                    type: '.key',
                    value: ''
                },
                {
                    text: this.fieldLabel('vin'),
                    type: 'vin',
                    value: ''
                },
                {
                    text: this.fieldLabel('make'),
                    type: 'make',
                    value: ''
                },
                {
                    text: this.fieldLabel('model'),
                    type: 'model',
                    value: ''
                },
                {
                    text: this.fieldLabel('year'),
                    type: 'year',
                    value: ''
                },
                {
                    text: this.$t('OrderCurrent.reference'),
                    type: 'numRef',
                    value: ''
                },
                {
                    text: this.$t('OrderCurrent.pickup'),
                    type: 'transmitterName',
                    value: ''
                },
                {
                    text: this.$t('OrderCurrent.delivery'),
                    type: 'receiverName',
                    value: ''
                }
            ],
            hideTitleonPrint: false
        }
    },

    props: {
        vinPrinting: Boolean,
        arrOfOrder: {
            type: Array,
            required: true
        },
        user: {
            type: Object,
            required: false,
            default: () => ({})
        }
    },

    methods: {
        sendToPrint () {
            this.hideTitleonPrint = true
            setTimeout(() => {
                printJS({
                printable: 'vinPrint',
                type: 'html',
                scanStyles: false
                })

                this.clearSelected()

                this.hideTitleonPrint = false
            }, 100)
        },
        clearSelected () {
            this.$emit('closePrintVin')
        }
    }
}
</script>
